import { Stack, Text } from '@mantine/core';

import { useGetNotesByPatientIdQuery } from '@/store/slices/api/clinicalNotesApiSlice';
import formatDate from '@/utils/formatDate';

interface StickyNoteTabProps {
  patientId: string;
  reportId?: number;
}

const StickyNoteTab = ({ patientId }: StickyNoteTabProps) => {
  const { data } = useGetNotesByPatientIdQuery(
    { patientId, limit: 50, page: 1 },
    { skip: !patientId }
  );
  const sticky = data?.notes?.find((note) => note.isSticky && !note.isArchived) ?? null;

  if (!sticky) {
    return (
      <Text size="sm" c="dimmed" py="md">
        No sticky note set for this patient. Pin a note as sticky from the Notes tab to surface it
        here.
      </Text>
    );
  }

  return (
    <Stack gap={6} py={4}>
      <Text size="sm" c="#1a1a2e" style={{ lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
        {sticky.content}
      </Text>
      <Text size="xs" c="dimmed">
        {[sticky.createdBy?.given, sticky.createdBy?.family].filter(Boolean).join(' ')}
        {sticky.createdAt ? ` · ${formatDate(sticky.createdAt, 'MMM D, YYYY, h:mm A')}` : ''}
      </Text>
    </Stack>
  );
};

export default StickyNoteTab;
